export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_receiver') || '接收人',
    field: 'receiver',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_copyTo') || '抄送人',
    field: 'copyTo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_taskStatus') || '推送状态',
    field: 'taskStatus',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'taskStatus' }
  },
  {
    title: that.$l('table_label_title') || '消息标题',
    field: 'title',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_content') || '消息内容',
    field: 'content',
    width: 100,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_variables') || '消息可变参数',
    field: 'variables',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_extraParams') || '扩展参数',
    field: 'extraParams',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_templateId') || '消息模版id',
    field: 'templateId',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_timeliness') || '时效类型',
    field: 'timeliness',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'timeliness' },
  },
  {
    title: that.$l('table_label_pushStrategy') || '推送策略',
    field: 'pushStrategy',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_pushTime') || '推送时间',
    field: 'pushTime',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.create') || '创建人',
    field: 'createByName',
    width: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
]
